/* eslint-disable import/no-default-export */
import React from 'react';
import styled from 'styled-components';
const colors = require('common/lib/colors/colors.less');
import { Board } from './Board';
import { ProportionalBoardLists } from './ProportionalLists';

const TopBar = styled.span`
  border-radius: 100px;
  background-color: ${colors.N10};
  display: block;
  height: 8px;
  margin-bottom: 16px;
  width: 112px;
`;

export const PlaceholderBoardTile = ({ numLists }) => (
  <Board bgColor={colors.N40A} loading numLists={numLists}>
    <TopBar />

    <ProportionalBoardLists
      lists={[
        { id: '1', size: 2 },
        { id: '2', size: 3 },
        { id: '3', size: 1 },
        { id: '4', size: 2 },
        { id: '5', size: 2 },
        { id: '6', size: 1 },
      ]}
      numLists={numLists}
    />
  </Board>
);

export default PlaceholderBoardTile;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-board/PlaceholderBoardTile.js